// @flow

import React, { PureComponent, type Node } from "react";
import type { UnaryFn } from "@tvg/types/Functional";
import { noop } from "lodash";
import TabAtom from "./styled-components";
import type { TagButton } from "../../_molecules/TabGroup/types";

export type TabProps = {
  /**
   * The tab title / text
   */
  title: string,
  /**
   * An optional tab sub title
   */
  subTitle?: Node,
  /**
   * If the tab is active
   */
  isActive: boolean,
  /**
   * A counter to show above the text on the tab (notification style)
   */
  isDisabled: boolean,
  /**
   * If the tab is disabled
   */
  counter: number,
  /**
   * If the tab is disabled
   */
  displayZero: boolean,
  /**
   * Callback to be executed when there's a tab click
   */
  onClick: UnaryFn<string, mixed>,
  /**
   * Element's QA label
   */
  qaLabel?: string,
  /**
   * Tab button type
   */
  type: "tab" | "subTab",
  /**
   * should Render pending tag might need a refactor in the future
   */
  tag: TagButton
};

export default class Tab extends PureComponent<TabProps> {
  static defaultProps = {
    title: "",
    subTitle: "",
    isSubtitleHighlighted: false,
    counter: 0,
    displayZero: false,
    isActive: false,
    isDisabled: false,
    onClick: noop,
    qaLabel: "tab",
    type: "tab",
    tag: { isVisible: false, text: "" }
  };

  render() {
    return (
      <TabAtom
        counter={this.props.counter}
        isActive={this.props.isActive}
        displayZero={this.props.displayZero}
        onClick={
          this.props.isDisabled
            ? noop
            : () => this.props.onClick(this.props.title)
        }
        isDisabled={this.props.isDisabled}
        qaLabel={this.props.qaLabel}
        type={this.props.type}
        text={this.props.title}
        tag={this.props.tag}
      >
        {this.props.subTitle ? this.props.subTitle : undefined}
      </TabAtom>
    );
  }
}
